export const TEMPLATE_PAGE_SEPARATOR = 'p';

export const PAYSTACK_REFERENCE_PREFIX = 'QAPBXWB';

export const MODALS = {
  CONFIRMATION_MODAL: 'CONFIRMATION_MODAL',
  LIGHT_BOX: 'LIGHT_BOX',
  FORM_MODAL: 'FORM_MODAL',
  ALERT_MODAL: 'ALERT_MODAL'
};

export const GENERIC_ERROR_MESSAGE =
  'Something went wrong.\nPlease check your connection and try again or contact support...';

export const LOG_OUT_TIMEOUT = 1000 * 60 * 5; // 5 minutes

export const TOAST_TIMEOUT = 1000 * 5; // 5 seconds
